import React from 'react';
import { I18nProvider } from './I18nProvider';

export function withI18nProvider(Component: React.ComponentType<any>) {
  const HOC = (props: any) => (
    <I18nProvider {...props}>
      <Component {...props} />
    </I18nProvider>
  );

  return HOC;
}
